import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref<any>({})
  const setUserInfo = async (userInfo: any) => {
    userInfo.value = userInfo
  }

  const activePage = ref<string>('')
  const setActivePage = async (nowPage: string) => {
    activePage.value = nowPage
  }

  return { setUserInfo, userInfo, activePage, setActivePage }
})
